import { defineMessages } from "react-intl";

export const messages = defineMessages({
  editExtra: {
    id: "extras.form.edit",
    defaultMessage: "Edit extra",
  },
  viewExtra: {
    id: "extras.form.view",
    defaultMessage: "View extra",
  },
  createExtra: {
    id: "extras.form.create",
    defaultMessage: "Create extra",
  },
  duplicateExtra: {
    id: "extras.form.duplicate",
    defaultMessage: "Duplicate extra",
  },
  extraTicker: {
    id: "extras.form.ticker",
    defaultMessage: "Ticker",
  },
  active: {
    id: "default.active",
    defaultMessage: "Active",
  },
  visible: {
    id: "extras.form.visible",
    defaultMessage: "Visible",
  },
  extras: {
    id: "extras.form.extras",
    defaultMessage: "Extras",
  },
  codes: {
    id: "extras.form.code",
    defaultMessage: "Coupon / company code",
  },
  emails: {
    id: "extras.form.emails",
    defaultMessage: "Emails List",
  },
  emailsHelperText: {
    id: "extras.form.emailsHelperText",
    defaultMessage: "Booking confirmation recipients",
  },
  availability: {
    id: "extras.form.availability",
    defaultMessage: "Availability",
  },
  applyTo: {
    id: "extras.form.applyTo",
    defaultMessage: "Apply to",
  },
  maxBookableUnits: {
    id: "extras.form.maxBookableUnits",
    defaultMessage: "Max. Bookable Units",
  },
  blockage: {
    id: "extras.form.blockage",
    defaultMessage: "Blocking",
  },
  validity: {
    id: "extras.form.validity",
    defaultMessage: "Validity",
  },
  minStay: {
    id: "extras.form.minStay",
    defaultMessage: "Min. Stay",
  },
  maxStay: {
    id: "extras.form.maxStay",
    defaultMessage: "Max. Stay",
  },
  minNotice: {
    id: "extras.form.minNotice",
    defaultMessage: "Min. Notice",
  },
  maxNotice: {
    id: "extras.form.maxNotice",
    defaultMessage: "Min. Notice",
  },
  rates: {
    id: "extras.form.rates",
    defaultMessage: "Rates",
  },
  promoId: {
    id: "extras.form.codes.promoId",
    defaultMessage: "Promo id",
  },
  type: { id: "extras.form.type", defaultMessage: "Type" },
  taxDescription: {
    id: "extras.form.tax.description",
    defaultMessage: "Extra as a fee – displayed in the checkout summary.",
  },
  typeRoom: { id: "extras.form.type.room", defaultMessage: "Per room" },
  typeRoomPerDay: { id: "extras.form.type.room.perDay", defaultMessage: "Per room/day" },
  typeRoomPerDayMandatory: {
    id: "extras.form.type.room.perDayMandatory",
    defaultMessage: "Per room/day (Mandatory)",
  },
  typeRoomMandatory: {
    id: "extras.form.type.room.mandatory",
    defaultMessage: "Per room (mandatory)",
  },
  typeRoomSpecificDate: {
    id: "extras.form.type.room.specificDate",
    defaultMessage: "Per room/specific date",
  },
  typePerson: { id: "extras.form.type.person", defaultMessage: "Per person" },
  typePersonPerDay: { id: "extras.form.type.person.perDay", defaultMessage: "Per person/day" },
  typePersonPerDayMandatory: {
    id: "extras.form.type.person.perDayMandatory",
    defaultMessage: "Per person/day (Mandatory)",
  },
  typePersonMandatory: {
    id: "extras.form.type.person.mandatory",
    defaultMessage: "Per person (mandatory)",
  },
  typePersonSpecificDate: {
    id: "extras.form.type.person.specificDate",
    defaultMessage: "Per person/specific date",
  },
  typeUnit: { id: "extras.form.type.unit", defaultMessage: "Per unit" },
  typeUnitPerDay: { id: "extras.form.type.unit.day", defaultMessage: "Per unit/day" },
  typeUnitSpecificDate: {
    id: "extras.form.type.unit.specificDate",
    defaultMessage: "Per unit/Specific Date",
  },
  rateType: { id: "extras.form.rate.type", defaultMessage: "Rate type" },
  rateTypeUnknown: { id: "extras.form.rate.type.unknown", defaultMessage: "--" },
  rateTypeConstant: { id: "extras.form.rate.type.constant", defaultMessage: "Constant" },
  rateTypeOwn: { id: "extras.form.rate.type.own", defaultMessage: "Own" },
  lockType: { id: "extras.form.lockType", defaultMessage: "Blocking and availability behaviour" },
  lockTypeStay: { id: "extras.form.lock.type.stay", defaultMessage: "Per stay" },
  lockTypeDay: { id: "extras.form.lock.type.day", defaultMessage: "Per day" },
  inventoryLines: {
    id: "extras.form.inventoryLines",
    defaultMessage: "Inventory Lines",
  },
  stayDates: {
    id: "extras.form.inventoryTable.validitySection",
    defaultMessage: "Validity (travel window)",
  },
  endDate: {
    id: "extras.form.endDate",
    defaultMessage: "End date",
  },
  fileManager: {
    id: "extras.form.accommodation.images",
    defaultMessage: "File manager",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
  presenceValidator: {
    id: "app.input.pressence",
    description: "ticker valdiation text",
    defaultMessage: "doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  tickerValidation: {
    id: "app.ticker.validation",
    description: "ticker valdiation text",
    defaultMessage: "doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  emptySpacesValidator: {
    id: "app.input.emtpySpacesValidator",
    description: "empty spaces are not allowed",
    defaultMessage: "empty spaces are not allowed",
  },
  maxLengthTickerValidator: {
    id: "app.ticker.maxLength",
    description: "Maximum characters: 8",
    defaultMessage: "Maximum characters: 8",
  },
  validEmailValidator: {
    id: "emailBlacklist.emailInvalid",
    description: "valid email format validator",
    defaultMessage: "Invalid email format",
  },
  minValueValidator: {
    id: "extra.minStay.minValueValidator",
    description: "Must be equal or higher than {minValue}",
    defaultMessage: "Must be equal or higher than {minValue}",
  },
  moreThanZero: {
    id: "app.contractableConditions.moreThanZero",
    description: "Must be more than 0",
    defaultMessage: "Must be more than 0",
  },
  tabsErrors: {
    id: "app.form.someTabsErrors",
    description: "error tabs text",
    defaultMessage: "Some tabs have errors.",
  },
  properties: {
    id: "internalmenu.crmBeta.properties",
    description: "properties",
    defaultMessage: "properties",
  },
  images: {
    id: "extras.tab.images",
    description: "images",
    defaultMessage: "Images",
  },
  oneTimePromoCode: {
    id: "extras.tab.oneTimePromoCode",
    description: "oneTimePromoCode",
    defaultMessage: "Single-Use promocode",
  },
  goBack: {
    id: "app.entityForm.goBack",
    description: "Go back to previous screen",
    defaultMessage: "Go back",
  },
  unlessOneExtraError: {
    id: "extra.unless.oneExtra",
    description: "Unless one extra is necessary for creating a extra",
    defaultMessage: "Unless one extra is necessary for creating a extra",
  },
  unlessOneInventoryLineError: {
    id: "extra.unless.oneInventoryLine",
    description: "Unless one inventory line is necessary for creating a extra",
    defaultMessage: "Unless one inventory line is necessary for creating a extra",
  },
  multiple: {
    id: "modification.translation.messages.multiple",
    description: "Multiple",
    defaultMessage: "Multiple",
  },
  propertiesTabValidator: {
    id: "extras.form.errors.properties",
    description: "Check the red fields on the properties tab",
    defaultMessage: "Check the red fields on the properties tab",
  },
  imagesHelpText: {
    id: "app.imagesHelpText",
    description: "Images Help Text",
    defaultMessage:
      "Las imágenes deben tener una resolución 1900 x 1080 pixeles y un tamaño máximo de 10MB.",
  },
  extraUseOwn: { id: "extras.form.use.own", defaultMessage: "Own" },
  extraUseUnknown: { id: "extras.form.use.unknown", defaultMessage: "--" },
  extraApplyToAllDaysExceptCheckOut: {
    id: "extras.form.applyTo.allDaysExceptCheckOut",
    defaultMessage: "All stay days except check-out",
  },
  extraApplyToAllDaysExceptCheckIn: {
    id: "extras.form.applyTo.allDaysExceptCheckIn",
    defaultMessage: "All stay days except check-in",
  },
  extraApplyToOnlyCheckIn: {
    id: "extras.form.applyTo.onlyCheckIn",
    defaultMessage: "Only check-in",
  },
  extraRestrictionUseConstant: {
    id: "extras.form.restriction.use.constant",
    defaultMessage: "Constant",
  },
  extraRestrictionUseUnknown: {
    id: "extras.form.restriction.use.unknown",
    defaultMessage: "Unlimited",
  },
  createErrorTitle: {
    id: "extras.form.create.error.title",
    defaultMessage: "Error creating extra",
  },
  createErrorDescription: {
    id: "extras.form.create.error.description",
    defaultMessage: "An error occurred while creating the extra",
  },
  createSuccessTitle: {
    id: "extras.form.create.success.title",
    defaultMessage: "Extra created",
  },
  createSuccessDescription: {
    id: "extras.form.create.success.description",
    defaultMessage: "The extra has been created successfully",
  },
  getOneErrorTitle: {
    id: "extras.form.getOne.error.title",
    defaultMessage: "Error getting extra",
  },
  getOneErrorDescription: {
    id: "extras.form.getOne.error.description",
    defaultMessage: "An error occurred while getting the extra",
  },
  updateSuccessTitle: {
    id: "extras.form.update.success.title",
    defaultMessage: "Extra updated",
  },
  updateSuccessDescription: {
    id: "extras.form.update.success.description",
    defaultMessage: "The extra has been updated successfully",
  },
  updateErrorTitle: {
    id: "extras.form.update.error.title",
    defaultMessage: "Error updating extra",
  },
  updateErrorDescription: {
    id: "extras.form.update.error.description",
    defaultMessage: "An error occurred while updating the extra",
  },
  getInventoryLinesExcelErrorTitle: {
    id: "extras.form.getInventoryLines.error.title",
    defaultMessage: "Error getting inventory lines",
  },
  getInventoryLinesExcelErrorDescription: {
    id: "extras.form.getInventoryLines.error.description",
    defaultMessage: "An error occurred while getting the inventory lines",
  },
  processInventoryLinesExcelErrorTitle: {
    id: "extras.form.processInventoryLines.error.title",
    defaultMessage: "Error processing inventory lines",
  },
  processInventoryLinesExcelErrorDescription: {
    id: "extras.form.processInventoryLines.error.description",
    defaultMessage: "An error occurred while processing the inventory lines",
  },
  loadPropertyInventoryErrorTitle: {
    id: "extras.form.loadPropertyInventory.error.title",
    defaultMessage: "Error loading property inventory",
  },
  loadPropertyInventoryErrorDescription: {
    id: "extras.form.loadPropertyInventory.error.description",
    defaultMessage: "An error occurred while loading the property inventory",
  },
  oneTimePromoCodeTemplateDownload: {
    id: "app.oneTimePromoCode.download",
    defaultMessage: "Download the single-use promotional code template",
  },
  oneTimePromoCodeTemplateDownloadButton: {
    id: "app.entityList.downloadExcel",
    defaultMessage: "Download excel",
  },
  oneTimePromoCodeTemplateUpload: {
    id: "app.oneTimePromoCode.upload",
    defaultMessage: "Upload the template with the new codes",
  },
  processOneTimePromoCodeExcelSuccessTitle: {
    id: "extras.form.processOneTimePromoCode.success.title",
    defaultMessage: "Promo codes processed",
  },
  processOneTimePromoCodeExcelSuccessDescription: {
    id: "extras.form.processOneTimePromoCode.success.description",
    defaultMessage: "The promo codes have been processed successfully",
  },
  processOneTimePromoCodeExcelErrorTitle: {
    id: "extras.form.processOneTimePromoCode.error.title",
    defaultMessage: "Error processing promo codes",
  },
  processOneTimePromoCodeExcelErrorDescription: {
    id: "extras.form.processOneTimePromoCode.error.description",
    defaultMessage: "An error occurred while processing promo codes",
  },
  downloadOneTimePromoCodeExcelErrorTitle: {
    id: "extras.form.downloadOneTimePromoCode.error.title",
    defaultMessage: "Error download promo codes",
  },
  downloadOneTimePromoCodeExcelErrorDescription: {
    id: "extras.form.downloadOneTimePromoCode.error.description",
    defaultMessage: "An error occurred while downloading promo codes",
  },
});

export const EXTRA_RATE_TYPE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_RATE_TYPE_UNKNOWN: { label: messages.rateTypeUnknown },
  EXTRA_RATE_TYPE_CONSTANT: { label: messages.rateTypeConstant },
  EXTRA_RATE_TYPE_OWN: { label: messages.rateTypeOwn },
};

export const EXTRA_TYPE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_TYPE_ROOM: { label: messages.typeRoom },
  EXTRA_TYPE_ROOM_PER_DAY: { label: messages.typeRoomPerDay },
  EXTRA_TYPE_ROOM_MANDATORY: { label: messages.typeRoomMandatory },
  EXTRA_TYPE_ROOM_PER_DAY_MANDATORY: { label: messages.typeRoomPerDayMandatory },
  EXTRA_TYPE_ROOM_SPECIFIC_DATE: { label: messages.typeRoomSpecificDate },
  EXTRA_TYPE_PERSON: { label: messages.typePerson },
  EXTRA_TYPE_PERSON_PER_DAY: { label: messages.typePersonPerDay },
  EXTRA_TYPE_PERSON_MANDATORY: { label: messages.typePersonMandatory },
  EXTRA_TYPE_PERSON_PER_DAY_MANDATORY: { label: messages.typePersonPerDayMandatory },
  EXTRA_TYPE_PERSON_SPECIFIC_DATE: { label: messages.typePersonSpecificDate },
  EXTRA_TYPE_UNIT: { label: messages.typeUnit },
  EXTRA_TYPE_UNIT_PER_DAY: { label: messages.typeUnitPerDay },
  EXTRA_TYPE_UNIT_SPECIFIC_DATE: { label: messages.typeUnitSpecificDate },
};

export const EXTRA_USE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_USE_UNKNOWN: { label: messages.extraUseUnknown },
  EXTRA_USE_OWN: { label: messages.extraUseOwn },
};

export const EXTRA_APPLY_TO_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKOUT: {
    label: messages.extraApplyToAllDaysExceptCheckOut,
  },
  EXTRA_APPLY_TO_ALL_STAY_DAYS_EXCEPT_CHECKIN: { label: messages.extraApplyToAllDaysExceptCheckIn },
  EXTRA_APPLY_TO_ONLY_CHECKIN: { label: messages.extraApplyToOnlyCheckIn },
};

export const EXTRA_MAX_UNITS_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  "1": { label: { id: "extras.maxUnits.1", defaultMessage: "1" } },
  "2": { label: { id: "extras.maxUnits.2", defaultMessage: "2" } },
  "3": { label: { id: "extras.maxUnits.3", defaultMessage: "3" } },
  "4": { label: { id: "extras.maxUnits.4", defaultMessage: "4" } },
  "5": { label: { id: "extras.maxUnits.5", defaultMessage: "5" } },
  "6": { label: { id: "extras.maxUnits.6", defaultMessage: "6" } },
  "7": { label: { id: "extras.maxUnits.7", defaultMessage: "7" } },
  "8": { label: { id: "extras.maxUnits.8", defaultMessage: "8" } },
  "9": { label: { id: "extras.maxUnits.9", defaultMessage: "9" } },
  "10": { label: { id: "extras.maxUnits.10", defaultMessage: "10" } },
};

export const EXTRA_LOCK_TYPE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_LOCK_TYPE_STAY: { label: messages.lockTypeStay },
  EXTRA_LOCK_TYPE_DAY: { label: messages.lockTypeDay },
};

export const EXTRA_RESTRICTION_USE_TYPE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  EXTRA_RESTRICTION_USE_UNKNOWN: { label: messages.extraRestrictionUseUnknown },
  EXTRA_RESTRICTION_USE_CONSTANT: { label: messages.extraRestrictionUseConstant },
};
